import React from 'react';
import AddIcon from '@material-ui/icons/Add';
export const PlusSquare = (props) => {
	return (
		<AddIcon fontSize="inherit" {...props} />
	);
}
